import { graphql, useStaticQuery } from 'gatsby';

import type { Lucid } from '../types/types';

interface ExternalLogoFiles {
  rasters: {
    edges: Lucid.Logo.File[];
  };
  vectors: {
    edges: Lucid.Logo.File[];
  };
}

const useExternalLogos = (logos: string[]) => {
  const { rasters, vectors }: ExternalLogoFiles = useStaticQuery(graphql`
    query useExternalLogosQuery {
      rasters: allExternalLogosJson(filter: { file: { ext: { ne: ".svg" } } }) {
        edges {
          node {
            file {
              childImageSharp {
                gatsbyImageData(width: 200)
              }
              publicURL
              name
            }
            alt
            slug
          }
        }
      }
      vectors: allExternalLogosJson(filter: { file: { ext: { eq: ".svg" } } }) {
        edges {
          node {
            file {
              publicURL
              name
            }
            alt
            slug
          }
        }
      }
    }
  `);

  const edges = [...rasters.edges, ...vectors.edges];
  const selectedLogos = logos.map(slug => edges.find(logo => logo.node.slug === slug));
  return selectedLogos;
};

export default useExternalLogos;
